import PropTypes from 'prop-types';
import { useLoaderData, useParams } from 'react-router';
import { pathwayTemplateAnalysisActions } from '@/stores/pathwayTemplateAnalysisStore';
import UnitConverter from './UnitConverter';

const LcaControl = () => {
  const { templateId } = useParams();
  const { pathwayTemplate } = useLoaderData();

  const onSubmit = data => {
    const { levelization_unit } = data;
    const params = levelization_unit ? { levelization_unit: JSON.parse(levelization_unit) } : {};
    pathwayTemplateAnalysisActions.fetchLca(templateId, params);
    pathwayTemplateAnalysisActions.fetchLcaBreakdown(templateId, params);
  };

  return (
    <div>
      <UnitConverter template={pathwayTemplate} onSubmit={onSubmit} />
    </div>
  );
};

LcaControl.propTypes = {
  template: PropTypes.object,
};

export default LcaControl;
